/****************************************************************************************************************
 * ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
 *
 * The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
 * other pending or existing intellectual property rights in India, the United States and other countries. The Program
 * may contain / reference third party or open source components, the rights to which continue to remain with the
 * applicable third party licensors or the open source community as the case may be and nothing here transfers the
 * rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
 * storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
 * photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
 * severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
 *****************************************************************************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { config } from '../ba-supplier-config';
import { Observable } from 'rxjs';
import { Constants } from '../ba-supplier-ui.constants';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { SuppDialogComponent } from '../components/supp-dialog/supp-dialog.component';
@Injectable()
export class CommonService {
  dialogResponse: any;
  constructor(private http: HttpClient, public snackBar: MatSnackBar, public dialog: MatDialog) { }
  getLocation(location = '', limit = 10) {
    let url = Constants.API_COMMON_URL.concat('/referenceData/searchLocations?');
    if (location.toString().trim().length == 0) {
      return null;
    } else {
      url = url.concat('?q=').concat(location).concat('&limit=').concat(limit.toString());
      return this.http.get(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      });
    }
  }
  getUom(searchTerm = '', limit = 10): Observable<any> {
    let url = Constants.API_COMMON_URL.concat('/uom/searchUom?');
    if (searchTerm.toString().trim().length == 0) {
      return null;
    } else {
      url = url.concat('q=').concat(searchTerm).concat('&limit=').concat(limit.toString());
      return this.http.get<any>(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      });
    }
  }
  getCurrency(searchTerm = '', limit = 10): Observable<any> {
    let url = Constants.API_COMMON_URL.concat('/currency/searchCurrency?');
    if (searchTerm.toString().trim().length == 0) {
      return null;
    } else {
      url = url.concat('q=').concat(searchTerm).concat('&limit=').concat(limit.toString());
      return this.http.get<any>(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      });
    }
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', {
      duration: 2000
    });
  }
  openDialog(title, content, modalType, callback): void {
    const modalWidth = '35rem';
    const modalHeight = '20rem';
    const dialogRef = this.dialog.open(SuppDialogComponent, {
      width: modalWidth,
      height: modalHeight,
      data: {
        title: title,
        content: content,
        type: modalType
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.dialogResponse = result;
      callback(result);
    });
  }
}


